import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingPageComponent} from './landing-component/landing-component.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'landing/:id',
    component: LandingPageComponent,
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'user-management',
    loadChildren: () =>
      import('./user-management/user-management.module').then(
        (m) => m.UserManagementModule
      ),
  },
  {
    path: 'asset-administration',
    loadChildren: () =>
      import('./asset-administration/asset-administration.module').then(
        (m) => m.AssetAdministrationModule
      ),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'region-management',
    loadChildren: () => import('./region-management/region-management.routes').then(m => m.routes),
  },
  {
    path: 'config',
    data: {
      breadcrumb: 'Config',
    },
    loadChildren: () => import('./config-management/config-management.routes').then(m => m.routes),
  },
  {
    path: 'enterprises',
    data: {
      breadcrumb: 'Enterprises',
    },
    loadChildren: () => import('./enterprises/enterprises.routes').then(m => m.routes),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
